//Modules
import React from "react"
//Components
import Layout from "../components/Layout/Layout"
import SEO from "../components/SEO/SEO"
import Qualifications from "../components/Qualifications/Qualifications"

const QualificationsPage = ({ data }) => (
  <Layout>
    <SEO title="Qualifications" description="Qualifications" />
    <Qualifications
      testimonials={data.testimonials.edges}
      qualifications={data.qualifications.edges}
    />
  </Layout>
)

export const query = graphql`
  {
    testimonials: allContentfulTestimonial {
      edges {
        node {
          name
          organisation
          body {
            body
          }
        }
      }
    }
    qualifications: allContentfulQualificationSection {
      edges {
        node {
          name
          body {
            json
          }
        }
      }
    }
  }
`

export default QualificationsPage
